<template>
  <nuxt-link
    :to="props.to"
    :external="props.external"
    aria-label="Home"
  >
    <u-logo
      :pro="props.pro"
      :width="props.width"
    />
  </nuxt-link>
</template>

<script setup lang="ts">
const definedProps = defineProps({
  to: {
    type: String,
    default: '/',
  },
  external: {
    type: Boolean,
    default: false,
  },
  pro: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 133,
  },
})
const props = useDefaults(definedProps, 'HeaderLogo')
</script>
